import React from 'react';
import HideAppBar from '../HomePage/components/HideAppBar'
import Footer from '../HomePage/components/Footer';
import ImageShow from './components/ImageShow';
import Content from './components/Content';
import './front.css'

const LayoutFront = ({ children }) => {
    
    return (
        <React.Fragment>            
            <HideAppBar />         
            <ImageShow />
            <Content children={children} />
            <Footer/>        
        </React.Fragment>
    )
}
export default LayoutFront
